import request from '@/commonUtils/request';
//企业人员信息 加个enterprise
export default {
  // 显示列表
  personListTable(params) {
    return request.post(
      '/enterprise/personnel/getPersonnelList',
      params
    );
  },
  // 新增
  newAddPerson(params) {
    return request.post(`/user/saveUser`, params).then((res) => res);
  },
  // 修改
  newEditPerson(params) {
    return request
      .post(`/enterprise/personnel/update`, params)
      .then((res) => res);
  },
  // 详情
  detailPerson(enterpriseUserId) {
    return request
      .get(
        `/enterprise/personnel/getPersonnelDetails?enterpriseUserId=${enterpriseUserId}`
      )
      .then((res) => res);
  },
  // 删除
  personnelmanagedelete(params) {
    return request
      .post(`/enterprise/personnel/delete`, params)
      .then((res) => res);
  },
  // 系统日志---列表
  pageList(params) {
    return request.post(`/log/system`, params).then((res) => res);
  },
  // 项目日志---列表
  projectList(params) {
    return request.post(`/log/project`, params).then((res) => res);
  },
  updateStatus(params) {
    return request.get(`/api/v1auth/updateStatus`, { params });
  },
  updatePassword(params) {
    return request({
      method: 'post',
      url: 'user/updatePassword',
      params,
    });
  },
  getNotJoinUserList(params) {
    return request
      .post(`/enterprise/personnel/getNotJoinPersonnelList`, params)
      .then((res) => res);
  },
  enabled(enterpriseUserId, enabled) {
    return request
      .get(
        `/enterprise/personnel/enabled?enterpriseUserId=${enterpriseUserId}&enabled=${enabled}`
      )
      .then((res) => res);
  },
  enterpriseGeteInviCode(params) {
    return request.post('/enterprise/invite/generateCode', params);
  },
  enterpriseimport(params) {
    return request
      .post(`/import-staff/importStaff`, params)
      .then((res) => res);
  },
  drawingDrawingQuesExport(params1) {
    return request({
      responseType: 'blob',
      url: '/enterprise/invite/import/downloadFailList',
      method: 'post',
      data: params1,
    });
  },
  drawingDrawingQuesExport2(params1) {
    return request({
      responseType: 'blob',
      url: '/import-staff/downloadFailList',
      method: 'post',
      data: params1,
    });
  },
  deleteInviteCodeByIds(params) {
    return request
      .post(`/enterprise/invite/deleteInviteCodeByPhones`, params)
      .then((res) => res);
  },
  //邀请人员 项目级别
  invitationPersonInPrj (params) {
    return request
    .post(
      `/enterprise/invite/generateCode`,
      params
    )
    .then(res => res);
  },
  // 修改人员信息
  updatePersonInfo(params) {
    return request.post('/enterprise/personnel/update',params)
  }
};
